module.exports = __webpack_public_path__ + "img/login-register-qr.a480322b.jpg";